import { Divider, Drawer, Grid, Typography } from '@mui/material';
import React, { useState } from 'react'
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss"
import chatLogsStyles from '../../../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import CallIcon from '@mui/icons-material/Call';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import { CALL_PERMISSION_REQUEST_OPTIONS } from '../../../constants';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import { useShallow } from 'zustand/react/shallow';

interface CallPermissionRequestTemplateProps {
    targetRef?: any,
}

const CallPermissionRequestTemplate: React.FC<CallPermissionRequestTemplateProps> = (props) => {
    
    const { targetRef } = props;
    const { currentActiveChatbotThread, getWabaNameAndPhoneNumberBytIntegratedChannelId } = useRuleBasedInboxStore(useShallow((state) => ({
        currentActiveChatbotThread: state.currentActiveChatbotThread,
        getWabaNameAndPhoneNumberBytIntegratedChannelId: state.getWabaNameAndPhoneNumberBytIntegratedChannelId
    })))

    const [openChoosePreferenceDrawer, setOpenChoosePreferenceDrawer] = useState<boolean>(false);

    const getWabaName = () => {
        const defaultChatbotName = "chatbot";
        if(currentActiveChatbotThread){
            const channelName = currentActiveChatbotThread?.channel_name;
            const integratedChannelId = currentActiveChatbotThread?.integrated_channel_id;

            return getWabaNameAndPhoneNumberBytIntegratedChannelId(channelName, integratedChannelId)?.waba_name ?? defaultChatbotName;
        }
        return defaultChatbotName;
    }

    return (
        <>
            <Grid container direction={"column"}>
                <Grid item xs={12} className={`${styles.callPermissionTemplateInfo}`}>
                    <Grid container className={`${styles.callPermissionTemplateInfoGrid}`}>
                        <Grid item className={styles.callPermissionCallIconGrid}>
                            <CallIcon className={styles.callPermissionCallIcon} />
                        </Grid>
                        <Grid item>
                            <Grid container gap={"2px"} direction={"column"}>
                                <Grid item>
                                    <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                        {`Can ${getWabaName()} call you?`}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography className={`${globalStyles.tertiaryFontSize} ${globalStyles.tertiaryFontWeight} ${styles.callPermissionTemplateDesc}`}>
                                        You can update your preference anytime in the businness profile
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Divider />
                <Grid item paddingBlock={"12px"} className={`${chatLogsStyles.chatLogsStyles} ${chatLogsStyles.chatLogsStyles} ${globalStyles.fullwidth} ${globalStyles.clickable}`}
                    onClick={() => setOpenChoosePreferenceDrawer(true)}
                >
                    <Grid container justifyContent={"center"} alignItems={"center"}>
                        <Grid item>
                            <Typography className={`${globalStyles.primaryColor} ${globalStyles.textCenter} ${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                Choose preference
                            </Typography>
                        </Grid>
                        <Grid item>
                            <KeyboardArrowDownIcon className={`${globalStyles.primaryColor} ${globalStyles.displayFlexStyle}`} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Drawer
                open={openChoosePreferenceDrawer}
                anchor='bottom'
                ref={targetRef ? targetRef.current : ""}
                onClose={() => setOpenChoosePreferenceDrawer(false)}
                variant="temporary"
                ModalProps={{
                    container: targetRef ? targetRef.current : "",
                    disableEnforceFocus: true,
                    style: { position: 'absolute' },
                    keepMounted: false,
                }}
                PaperProps={{
                    container: targetRef ? targetRef.current : "",
                    style: { position: 'absolute' },
                }}
                className={chatLogsStyles.buttonDrawer}
                BackdropProps={{ style: { position: "absolute" } }}
                SlideProps={{
                    direction: openChoosePreferenceDrawer ? "up" : "down",
                    timeout: { enter: 0, exit: 0 },
                    className: chatLogsStyles.buttonDrawerSlideStyle
                }}
            >
                <Grid container direction={"column"} gap={"18px"} marginBottom={"15px"}>
                    <Grid item xs={12} className={`${chatLogsStyles.drawerContainerBoxStyle} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`} gap={"12px"}>
                        <CloseIcon className={`${styles.closeDrawerIconStyle} ${globalStyles.clickable}`} onClick={() => setOpenChoosePreferenceDrawer(false)} />
                        <span className={chatLogsStyles.allOptionTextStyle}>
                            {`Can ${getWabaName()} call you?`}
                        </span>
                    </Grid>
                </Grid>
                {CALL_PERMISSION_REQUEST_OPTIONS?.map((option: string) => {
                    return <Grid item padding={"10px"} className={`${chatLogsStyles.templatePreviewButtonItem} ${chatLogsStyles.templatePreviewButtonItemBorder}`}>
                        <Grid item>
                            {option}
                        </Grid>
                    </Grid>
                })}
            </Drawer>
        </>
    )
}

export default CallPermissionRequestTemplate
